import {
  sexTypes,
  homeTypes,
  marriageStatuses,
  numberOfChildren,
  workForms,
  bizTypes,
  jobTypes,
  staffNums,
  repaymentDates,
  residenceYears,
} from "@/constants/constant";
import { goToErrorPage } from "@/utils/Other";

// IRET_VUE2EOL-168 服部確認済み
export const substrNkyNgt = (start, length, nky_ngt) => {
  try {
    if (nky_ngt) {
      return nky_ngt.toString().substr(start, length);
    }
    return "";
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-168 服部確認済み
export const substrNshNgt = (start, length, nsh_ngt) => {
  try {
    if (nsh_ngt) {
      return nsh_ngt.toString().substr(start, length);
    }
    return "";
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-168 服部確認済み
export const substrBth = (start, length, bth) => {
  try {
    if (bth) {
      return bth.toString().substr(start, length);
    }
    return "";
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-172 服部確認済み
export const setGrossSalary = (input_gross_salary) => {
  try {
    let grossSalary = String(input_gross_salary).trim();
    if (grossSalary && !isNaN(grossSalary)) {
      if (grossSalary.indexOf(".") !== 0) {
        return parseInt(grossSalary) * 10000;
      }
    }
    return "";
  } catch (e) {
    goToErrorPage(e);
  }
};

// 呼び方 確認済
// userData.nky_ngt = setNkyNgt(nkyNgtYyyy, nkyNgtMm);
export const setNkyNgt = (nkyNgtYyyy, nkyNgtMm) => {
  try {
    if (nkyNgtYyyy && nkyNgtMm) {
      return (
        nkyNgtYyyy.toString().trim() +
        ("0" + nkyNgtMm.toString().trim()).slice(-2) +
        "01"
      );
    } else {
      return "";
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
// IRET_VUE2EOL-169 服部確認済み
export const setNkyNgtYyyy = (nky_ngt) => {
  try {
    if (nky_ngt) {
      return Number(nky_ngt.toString().substr(0, 4));
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
// IRET_VUE2EOL-169 服部確認済み
export const setNkyNgtMm = (nky_ngt) => {
  try {
    if (nky_ngt) {
      return Number(nky_ngt.toString().substr(4, 2));
    }
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-172 服部確認済み
export const setNshNgt = (nshNgtYyyy, nshNgtMm) => {
  try {
    if (nshNgtYyyy && nshNgtMm) {
      return (
        nshNgtYyyy.toString().trim() +
        ("0" + nshNgtMm.toString().trim()).slice(-2) +
        "01"
      );
    } else {
      return "";
    }
  } catch (e) {
    goToErrorPage(e);
  }
};
// IRET_VUE2EOL-172 服部確認済み
export const setNshNgtYyyy = (nsh_ngt) => {
  try {
    if (nsh_ngt) {
      return Number(nsh_ngt.toString().substr(0, 4));
    }
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-172 服部確認済み
export const setNshNgtMm = (nsh_ngt) => {
  try {
    if (nsh_ngt) {
      return Number(nsh_ngt.toString().substr(4, 2));
    }
  } catch (e) {
    goToErrorPage(e);
  }
};

// まだ未確認（エラーのためコメントアウト
// export const setPhoneAu = (data, userData) => {
//   return (userData = {
//     phone_au_1: data.phone1,
//     phone_au_2: data.phone2,
//     phone_au_3: data.phone3,
//   });
// };

// IRET_VUE2EOL-169 服部確認済み
export const setPhoneMobile = (phone1, phone2, phone3) => {
  return {
    phone_mobile_1: phone1,
    phone_mobile_2: phone2,
    phone_mobile_3: phone3,
  };
};

// IRET_VUE2EOL-168 服部確認済み
export const setHasPhoneAu = (phone_au_1, phone_au_2, phone_au_3) => {
  return !!phone_au_1 && !!phone_au_2 && !!phone_au_3;
};

// IRET_VUE2EOL-168 服部確認済み
export const setHasPhoneMobile = (
  phone_mobile_1,
  phone_mobile_2,
  phone_mobile_3
) => {
  return !!phone_mobile_1 && !!phone_mobile_2 && !!phone_mobile_3;
};

// IRET_VUE2EOL-108_2 杜確認済み
export const setHasSex = (eva_sbt) => {
  return !!eva_sbt;
};

// IRET_VUE2EOL-108_2 杜確認済み
export const setHasBth = (eva_birth) => {
  return !!eva_birth;
};

// IRET_VUE2EOL-172 服部確認済み
export const setOfficePhone = (phone1, phone2, phone3) => {
  return {
    office_phone_1: phone1,
    office_phone_2: phone2,
    office_phone_3: phone3,
  };
};

export const createDisplayPhone = (phone1, phone2, phone3) => {
  let list = [];
  if (phone1) {
    list.push(phone1);
  }
  if (phone2) {
    list.push(phone2);
  }
  if (phone3) {
    list.push(phone3);
  }
  return list.join("-");
};

export const displayNameKanji = (userData) => {
  return userData.lastname_kanji + " " + userData.firstname_kanji;
};

export const displayNameKana = (userData) => {
  return userData.lastname_kana + " " + userData.firstname_kana;
};

// IRET_VUE2EOL-168 服部確認済み
export const displayBth = (bth) => {
  return bthYyyy(bth) + "年 " + bthMm(bth) + "月 " + bthDd(bth) + "日";
};

// IRET_VUE2EOL-168 服部確認済み
export const bthYyyy = (bth) => {
  return substrBth(0, 4, bth);
};

// IRET_VUE2EOL-168 服部確認済み
export const bthMm = (bth) => {
  if (substrBth(4, 2, bth)) {
    return String(Number(substrBth(4, 2, bth)));
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const bthDd = (bth) => {
  if (substrBth(6, 2, bth)) {
    return String(Number(substrBth(6, 2, bth)));
  }
  return "";
};

// IRET_VUE2EOL-108_2 杜確認済み
export const displaySex = (sex) => {
  for (let sexType of sexTypes) {
    if (sexType.value === sex) {
      return sexType.name;
    }
  }
  return "";
};

export const displayRepaymentDate = (userData) => {
  for (let repaymentDate of repaymentDates) {
    if (repaymentDate.value === userData.repayment_date) {
      return repaymentDate.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayPostcode = (postcode) => {
  try {
    return (
      postcode.toString().substr(0, 3) + "-" + postcode.toString().substr(3, 4)
    );
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-168 服部確認済み
export const displayAddress = (
  address_region,
  address_city,
  address_street,
  address_building
) => {
  return address_region + address_city + address_street + address_building;
};

// IRET_VUE2EOL-168 服部確認済み
export const displayHomeType = (home_type) => {
  for (let homeType of homeTypes) {
    if (homeType.value === home_type) {
      return homeType.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayJkyNgt = (nky_ngt) => {
  for (let residenceYear of residenceYears) {
    if (residenceYear.value === nky_ngt) {
      return residenceYear.name;
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNkyNgt = (nky_ngt) => {
  return displayNkyNgtYyyy(nky_ngt) + "年" + displayNkyNgtMm(nky_ngt) + "月〜";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNkyNgtYyyy = (nky_ngt) => {
  return substrNkyNgt(0, 4, nky_ngt);
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNkyNgtMm = (nky_ngt) => {
  if (substrNkyNgt(4, 2, nky_ngt)) {
    return String(Number(substrNkyNgt(4, 2, nky_ngt)));
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayRentLoanAmount = (rent_loan_amount) => {
  return Number(rent_loan_amount).toLocaleString() + "円／月";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayMarriageStatus = (marriage_status) => {
  for (let marriageStatus of marriageStatuses) {
    if (marriageStatus.value === marriage_status) {
      return marriageStatus.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNumberOfChildren = (number_of_children) => {
  for (let numberOfChild of numberOfChildren) {
    if (numberOfChild.value === number_of_children) {
      return numberOfChild.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayEzMail = (ez_mail) => {
  return ez_mail ? ez_mail : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayMail1 = (mail_1) => {
  return mail_1 ? mail_1 : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayMail2 = (mail_2) => {
  return mail_2 ? mail_2 : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayLoanMail = (loan_mail) => {
  return loan_mail ? loan_mail : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayLoanMailDisp = (loan_mail_disp) => {
  return loan_mail_disp ? loan_mail_disp : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayWorkForm = (work_form) => {
  for (let workForm of workForms) {
    if (workForm.value === work_form) {
      return workForm.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayBizType = (biz_type) => {
  for (let bizType of bizTypes) {
    if (bizType.value === biz_type) {
      return bizType.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayJobType = (job_type) => {
  for (let jobType of jobTypes) {
    if (jobType.value === job_type) {
      return jobType.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayStaffNum = (staff_num) => {
  for (let staffNum of staffNums) {
    if (staffNum.value === staff_num) {
      return staffNum.name.replace("<br>", "");
    }
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNshNgt = (nsh_ngt) => {
  return displayNshNgtYyyy(nsh_ngt) + "年" + displayNshNgtMm(nsh_ngt) + "月〜";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNshNgtYyyy = (nsh_ngt) => {
  return substrNshNgt(0, 4, nsh_ngt);
};

// IRET_VUE2EOL-168 服部確認済み
export const displayNshNgtMm = (nsh_ngt) => {
  if (substrNshNgt(4, 2, nsh_ngt)) {
    return String(Number(substrNshNgt(4, 2, nsh_ngt)));
  }
  return "";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayPhoneAu = (phone_au_1, phone_au_2, phone_au_3) => {
  return createDisplayPhone(phone_au_1, phone_au_2, phone_au_3);
};

// IRET_VUE2EOL-168 服部確認済み
export const displayPhoneMobile = (
  hasPhoneMobile,
  phone_mobile_1,
  phone_mobile_2,
  phone_mobile_3
) => {
  return hasPhoneMobile
    ? createDisplayPhone(phone_mobile_1, phone_mobile_2, phone_mobile_3)
    : "未設定";
};

// IRET_VUE2EOL-168 服部確認済み
export const displayOfficePhone = (
  office_phone_1,
  office_phone_2,
  office_phone_3
) => {
  return createDisplayPhone(office_phone_1, office_phone_2, office_phone_3);
};

// IRET_VUE2EOL-168 服部確認済み
export const displayGrossSalary = (gross_salary) => {
  return parseInt(gross_salary / 10000) + "万円";
};

// IRET_VUE2EOL-109 杜確認済み
export const showWorkFormMessage = (work_form) => {
  try {
    return work_form === "09" || work_form === "10";
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-109 杜確認済み
export const showWorkFormMessage02 = (work_form) => {
  try {
    return work_form === "07";
  } catch (e) {
    goToErrorPage(e);
  }
};

// IRET_VUE2EOL-168 服部確認済み
export const auUser = (id_type) => {
  return id_type === "0";
};

// IRET_VUE2EOL-175 服部確認済み
export const localUser = (id_type) => {
  return id_type === "99";
};

// IRET_VUE2EOL-168 服部確認済み
export const showLoanMail = (ez_mail, mail_1, mail_2) => {
  return !ez_mail && !mail_1 && !mail_2;
};

// IRET_VUE2EOL-168 服部確認済み
export const showDefaultMail = (ez_mail, mail_1, mail_2) => {
  return ez_mail || mail_1 || mail_2;
};

// 電話番号の先頭3桁確認
export const checkMobilePhoneDigits = (phone1) => {
  return ['090', '080', '070', '060'].includes(phone1);
};